export const FLOAT_NUMBER_WITH_MAX_ONE_DECIMAL = /^[0-9]*\.?[0-9]?$/;
export const FLOAT_NUMBER_WITH_MAX_TWO_DECIMALS = /^[0-9]*\.?[0-9]{0,2}$/;
export const FLOAT_NUMBER_WITH_MAX_THREE_DECIMALS = /^[0-9]*\.?[0-9]{0,3}$/;
export const POSITIVE_INTEGER = /^[0-9]*[1-9][0-9]*$/;
export const EMPTY_STRING = /^$/;
export const DOMAIN_NAME = /^(www\.)?([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/;
